import type { ImagePreset, InteractionMode, StudioConfig } from './types';

export const imagePresets: ImagePreset[] = [
  {
    id: 'lithos',
    name: '地质岩层',
    description: '炽热岩层 → 苔藓复苏',
    images: { a: '/assets/lithos-base.webp', b: '/assets/lithos-reveal.webp' },
    filenames: { a: 'lithos-base.webp', b: 'lithos-reveal.webp' },
  },
  {
    id: 'obsidian',
    name: '黑曜晶脉',
    description: '休眠岩桥 → 晶体觉醒',
    images: { a: '/assets/mask-obsidian-dormant.png', b: '/assets/mask-obsidian-awakened.png' },
    filenames: { a: 'mask-obsidian-dormant.png', b: 'mask-obsidian-awakened.png' },
  },
  {
    id: 'tech-city',
    name: '科技城市侵蚀',
    description: '智慧城市 → 自然接管',
    images: { a: '/assets/mask-tech-city-intact.png', b: '/assets/mask-tech-city-reclaimed.png' },
    filenames: { a: 'mask-tech-city-intact.png', b: 'mask-tech-city-reclaimed.png' },
  },
];

export const initialConfig: StudioConfig = {
  brand: 'Tactile Studio',
  eyebrow: 'Geological stories',
  title: 'Layers hold\ntales of time',
  subtitle: 'A living archive beneath your feet',
  description: 'Every layer of sediment records a chapter of our planet. Move through the surface and uncover what time has been holding.',
  cta: 'Explore the layers',
  mode: 'spotlight',
  primary: '#e31335',
  accent: '#ff6a00',
  background: '#08080a',
  titleSize: 76,
  fontStyle: 'editorial',
  fit: 'cover',
  brightness: 86,
  contrast: 112,
  saturation: 104,
  blur: 0,
  vignette: 54,
  imageAScale: 1,
  imageBScale: 1,
  imageAFocalX: 50,
  imageAFocalY: 50,
  imageBFocalX: 50,
  imageBFocalY: 50,
  radius: 250,
  feather: 86,
  follow: 12,
  splitFeather: 12,
  waveAmplitude: 34,
  waveFrequency: 3,
  waveSpeed: 42,
  brushSize: 150,
  brushFeather: 52,
  erasePersist: true,
  autoRecover: 24,
  parallaxDepth: 22,
  parallaxZoom: 8,
  parallaxBlur: 2,
  parallaxBalance: 46,
  parallaxBlend: 18,
};

export const modeMeta: Array<{
  id: InteractionMode;
  label: string;
  short: string;
  metaphor: string;
}> = [
  { id: 'spotlight', label: '聚光揭示', short: 'Spotlight', metaphor: '看见隐藏结构' },
  { id: 'split', label: '时间切片', short: 'Timeline', metaphor: '拖动穿越状态' },
  { id: 'wave', label: '波浪侵蚀', short: 'Wave', metaphor: '让变化向前推进' },
  { id: 'erase', label: '擦除显影', short: 'Erase', metaphor: '恢复被覆盖的记忆' },
  { id: 'parallax', label: '视差分层', short: 'Parallax', metaphor: '把平面拉出深度' },
];

export const presets: Array<{ name: string; patch: Partial<StudioConfig> }> = [
  {
    name: '地质探索',
    patch: { primary: '#e31335', accent: '#ff6a00', background: '#08080a', brightness: 86, contrast: 112, saturation: 104, vignette: 54, fontStyle: 'editorial' },
  },
  {
    name: '生态恢复',
    patch: { primary: '#0f9f6e', accent: '#b8f03c', background: '#07100c', brightness: 92, contrast: 108, saturation: 118, vignette: 42, fontStyle: 'grotesk' },
  },
  {
    name: '未来科技',
    patch: { primary: '#e31366', accent: '#61d9ff', background: '#05070c', brightness: 88, contrast: 120, saturation: 110, vignette: 62, fontStyle: 'mono' },
  },
  {
    name: '艺术修复',
    patch: { primary: '#a43c44', accent: '#e4b866', background: '#100b0c', brightness: 98, contrast: 104, saturation: 90, vignette: 36, fontStyle: 'editorial' },
  },
];
